import ReactDOM from "react-dom/client";
import FindOrganizationsMap from "./FindOrganizationsMap/FindOrganizationsMap.jsx";
const components = {
    FindOrganizationsMap,
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-react-component]").forEach((el) => {
        const componentName = el.getAttribute("data-react-component");
        const Component = components[componentName];

        if (Component) {
            const root = ReactDOM.createRoot(el);
            root.render(<Component />);
        } else {
            console.warn(`No component found for name "${componentName}".`);
        }
    });
});
